export interface IApplicationState {
    winningSymbolId: number,
    startWinDrop: boolean,
    multiplierValue: number,
    currentWonAmount: number,
    winDropCount: number,
    clearWinPanel: boolean,
    winDropList: any,
    winDropObjList: any,
    winPanelStackFull: any,
};

const initialState: IApplicationState = {
    winningSymbolId: -1,
    multiplierValue: -1,
    startWinDrop: false,
    currentWonAmount: -1,
    winDropCount: -1,
    clearWinPanel: false,
    winDropList: [],
    winPanelStackFull: false,
    winDropObjList: []
};

export enum actionTypes {
    SET_WINNING_SYMBOLID = '@@winDrop/SET_WINNING_SYMBOLID',
    START_WIN_DROP = '@@winDrop/START_WIN_DROP',
    SET_MULTIPIER_VALUE = '@@winDrop/SET_MULTIPIER_VALUE',
    SET_CURRENT_WON_AMOUNT = '@@winDrop/SET_CURRENT_WON_AMOUNT',
    SET_WIN_DROP_COUNT = '@@winDrop/SET_WIN_DROP_COUNT',
    CLEAR_WIN_PANEL = '@@winDrop/CLEAR_WIN_PANEL',
    SET_WIN_DROP_LIST = '@@winDrop/SET_WIN_DROP_LIST',
    SET_WIN_PANEL_STACK_FULL = '@@winDrop/SET_WIN_PANEL_STACK_FULL',
    SET_WIN_DROP_OBJECT_LIST = '@@winDrop/SET_WIN_DROP_OBJECT_LIST',
    RESET_WIN_PANEL_STATE = '@@winDrop/RESET_WIN_PANEL_STATE'
}


export function reducer(
    state: IApplicationState = initialState,
    action: any,
): IApplicationState {
    const { clearWinPanel } = state;
    const { symbolId, multiplierValue, currentWonAmount, startWinDrop, dropList, dropObjList, winPanelStackFull } = action;

    switch (action.type) {
        case actionTypes.SET_WINNING_SYMBOLID:
            return {
                ...state, winningSymbolId: symbolId,
            };
        case actionTypes.SET_MULTIPIER_VALUE:
            return {
                ...state, multiplierValue: multiplierValue,
            };
        case actionTypes.SET_CURRENT_WON_AMOUNT:
            return {
                ...state, currentWonAmount: currentWonAmount,
            };
        case actionTypes.START_WIN_DROP:
            return {
                ...state, startWinDrop: startWinDrop,
            };
        case actionTypes.SET_WIN_DROP_COUNT:
            return {
                ...state, winDropCount: state.winDropCount + 1,
            };
        case actionTypes.CLEAR_WIN_PANEL:
            return {
                ...state, clearWinPanel: clearWinPanel,
            };
        case actionTypes.SET_WIN_DROP_LIST:
            return {
                ...state, winDropList: dropList,
            };
        case actionTypes.SET_WIN_PANEL_STACK_FULL:
            return {
                ...state, winPanelStackFull: true,
            };
        case actionTypes.SET_WIN_DROP_OBJECT_LIST:
            return {
                ...state, winDropObjList: dropObjList,
            };
        case actionTypes.RESET_WIN_PANEL_STATE:


            return {
                ...state,
                winningSymbolId: -1,
                multiplierValue: -1,
                currentWonAmount: -1,
                winDropCount: -1,
                clearWinPanel: false,
                startWinDrop: false,
                winPanelStackFull: false,
            }
        default:
            return state;
    }
}

export const actions = {
    setWinningSymbolId: (symbolId: number): any => ({ type: actionTypes.SET_WINNING_SYMBOLID, symbolId }),
    setMultiplierValue: (multiplierValue: number): any => ({ type: actionTypes.SET_MULTIPIER_VALUE, multiplierValue }),
    setCurrentWonAmount: (wonAmount: number): any => ({ type: actionTypes.SET_CURRENT_WON_AMOUNT, wonAmount }),
    setStartWinDrop: (startWinDrop: number): any => ({ type: actionTypes.START_WIN_DROP, startWinDrop}),
    setWinDropCount: (): any => ({ type: actionTypes.SET_WIN_DROP_COUNT }),
    resetWinDropState: (): any => ({ type: actionTypes.RESET_WIN_PANEL_STATE }),
    setWinPanelStackFull: (): any => ({ type: actionTypes.SET_WIN_PANEL_STACK_FULL }),
    setClearWinPanel: (clearStack: boolean): any => ({ type: actionTypes.CLEAR_WIN_PANEL, clearStack }),
    setWinDropList: (dropList: any): any => ({ type: actionTypes.SET_WIN_DROP_LIST, dropList }),
    setWinDropObjectList: (dropObj: any): any => ({ type: actionTypes.SET_WIN_DROP_OBJECT_LIST, dropObj })
};